import { cn } from '../../lib/cn';
import type { FeatureAcceptanceRow } from '../../enterpriseacceptance/framework';

type Props = { items?: FeatureAcceptanceRow[] };

export function FeatureAcceptancePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((i) => (
        <div key={i.feature} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{i.feature}</p>
              <p className="text-xs text-slate-500">{i.owner} · {i.severity}</p>
            </div>
            <div className="text-right">
              <span className={cn(
                'rounded-full px-2 py-0.5 text-xs font-medium',
                i.signedOff ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
                i.status === 'passed' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' :
                'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
              )}>
                {i.signedOff ? 'signed off' : i.status.replace('_', ' ')}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
